var map = {
	"./ans": 351,
	"./ans.json": 351,
	"./data": 352,
	"./data.json": 352,
	"./img/map_icon.png": 56,
	"./img/satellite_icon.jpg": 57,
	"./img/satellite_icon.png": 795,
	"./img/shibaken.jpg": 311,
	"./logo.png": 796,
	"./marker-blue-locked.svg": 797,
	"./marker-gray-locked.svg": 93,
	"./marker-green-locked.svg": 312,
	"./marker-green-unlocked.svg": 798,
	"./marker-orange-locked.svg": 799,
	"./marker-red-locked.svg": 313,
	"./marker-yellow-locked.svg": 314,
	"./marker_shadow.png": 800
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 134;


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = 134
// module chunks = 0